// extracted by mini-css-extract-plugin
module.exports = {"stepRow":"orderDetail_stepRow__3-zrs","stepCircle":"orderDetail_stepCircle__9bS8a","done":"orderDetail_done__8k2In","todo":"orderDetail_todo__ttC3S"};